import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/regist', component: () => import('@/views/login/regist'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {title: 'home', icon: 'home'}
      },
      {
        path: 'person',
        name: 'person',
        component: () => import('@/views/person'),
        meta: {title: 'my'},
        hidden: true
      }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      // {
      //   path: 'order',
      //   name: 'order',
      //   component: () => import('@/views/oms/order/index'),
      //   meta: {title: '订单列表', icon: 'product-list'}
      // },
      // {
      //   path: 'orderDetail',
      //   name: 'orderDetail',
      //   component: () => import('@/views/oms/order/orderDetail'),
      //   meta: {title: '订单详情'},
      //   hidden:true
      // },
      // {
      //   path: 'deliverOrderList',
      //   name: 'deliverOrderList',
      //   component: () => import('@/views/oms/order/deliverOrderList'),
      //   meta: {title: '发货列表'},
      //   hidden:true
      // },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path:'/objects',
    component: Layout,
    name: 'objects',
    meta: {title: '合约'},
    children: [
      {
        path: 'obtype',
        name: 'obtype',
        component: () => import('@/views/objects/obtype/index'),
        meta: {title: '合约分类'}
      },
      {
        path: 'oblist',
        name: 'oblist',
        component: () => import('@/views/objects/oblist/index'),
        meta: {title: '合约列表'}
      },
      {
        path: 'addOb',
        name: 'addOb',
        component: () => import('@/views/objects/oblist/add'),
        meta: {title: '新增合约'}
      },
      {
        path: 'shuhai',
        name: 'shuhai',
        component: () => import('@/views/objects/oblist/shuhai'),
        meta: {title: '数海客户端'}
      },
      {
        path: 'dataSourse',
        name: 'dataSourse',
        component: () => import('@/views/objects/sourse/index'),
        meta: {title: '数据源管理'}
      },
      {
        path: 'inject',
        name: 'inject',
        component: () => import('@/views/objects/inject/index'),
        meta: {title: '插针'}
      }
    ]
  },
  {
    path:'/exchange',
    component: Layout,
    name: 'exchange',
    meta: {title: '交易'},
    children: [
      {
        path: 'entrust',
        name: 'entrust',
        component: () => import('@/views/exchange/entrust'),
        meta: {title: '挂单管理'}
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/exchange/order'),
        meta: {title: '持仓管理'}
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('@/views/exchange/history'),
        meta: {title: '历史订单'}
      },
      {
        path: 'profitOrder',
        name: 'profitOrder',
        component: () => import('@/views/exchange/profitOrder'),
        meta: {title: '盈利宝订单'}
      },
    ]
  },
  {
    path:'/content',
    component: Layout,
    redirect: '/content/advertise',
    name: 'content',
    meta: {title: '内容'},
    children: [
      {
        path: 'advertise',
        name: 'advertise',
        component: () => import('@/views/content/advertise/index'),
        meta: {title: '首页轮播'}
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('@/views/content/activity/index'),
        meta: {title: '活动中心'}
      },
      {
        path: 'announcemanage',
        name: 'announcemanage',
        component: () => import('@/views/content/announcemanage/index'),
        meta: {title: '公告管理'}
      },
      {
        path: 'addAnnouncemanage',
        name: 'addAnnouncemanage',
        component: () => import('@/views/content/announcemanage/add'),
        meta: {title: '添加公告'},
        hidden: true
      },
      {
        path: 'help',
        name: 'help',
        component: () => import('@/views/content/help/index'),
        meta: {title: '帮助管理'}
      },
      {
        path: 'addHelp',
        name: 'addHelp',
        component: () => import('@/views/content/help/add'),
        meta: {title: '添加帮助'},
        hidden: true
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/content/news/index'),
        meta: {title: '新闻管理'}
      },
      {
        path: 'addNews',
        name: 'addNews',
        component: () => import('@/views/content/news/add'),
        meta: {title: '添加新闻'},
        hidden: true
      },
      {
        path: 'survey',
        name: 'survey',
        component: () => import('@/views/content/survey/index'),
        meta: {title: '调查问卷管理'}
      },
      {
        path: 'explain',
        name: 'explain',
        component: () => import('@/views/content/explain/index'),
        meta: {title: '文档说明'}
      },
      {
        path: 'video',
        name: 'video',
        component: () => import('@/views/content/video/index'),
        meta: {title: '视频管理'}
      },
      {
        path: 'Strategy',
        name: 'Strategy',
        component: () => import('@/views/content/Strategy/index'),
        meta: {title: '策略管理'}
      },
      {
        path: 'college',
        name: 'college',
        component: () => import('@/views/content/college/index'),
        meta: {title: '投资学院管理'}
      },
    ]
  },
  {
    path:'/user',
    component: Layout,
    redirect: '/user/management',
    name: 'user',
    meta: {title: '用户'},
    children: [
      {
        path: 'management',
        name: 'management',
        component: () => import('@/views/user/management/index'),
        meta: {title: '用户管理'}
      },
      {
        path: 'proxy',
        name: 'proxy',
        component: () => import('@/views/user/proxy/index'),
        meta: {title: '代理管理'}
      },
      {
        path: 'addProxy',
        name: 'addProxy',
        component: () => import('@/views/user/proxy/add'),
        meta: {title: '添加代理'},
        hidden: true
      },
      {
        path: 'setRules',
        name: 'setRules',
        component: () => import('@/views/user/proxy/setRules'),
        meta: {title: '设置佣金规则'},
        hidden: true
      },
      {
        path: 'lookProxy',
        name: 'lookProxy',
        component: () => import('@/views/user/proxy/lookOver'),
        meta: {title: '查看代理详情'},
        hidden: true
      },
      {
        path: 'verified',
        name: 'verified',
        component: () => import('@/views/user/verified/index'),
        meta: {title: '实名认证'},
      },
      {
        path: 'lookOver',
        name: 'lookOver',
        component: () => import('@/views/user/management/lookOver'),
        meta: {title: '查看用户详情'},
        hidden: true
      },
      {
        path: 'verifiedDetail',
        name: 'verifiedDetail',
        component: () => import('@/views/user/verified/detail'),
        meta: {title: '实名认证详情'},
        hidden: true
      },
      {
        path: 'verifiedReview',
        name: 'verifiedReview',
        component: () => import('@/views/user/verified/review'),
        meta: {title: '实名认证审核'},
        hidden: true
      },
      {
        path: 'myTeam',
        name: 'myTeam',
        component: () => import('@/views/user/proxy/myTeam'),
        meta: {title: '我的团队'},
        hidden: true
      },
      {
        path: 'downTeam',
        name: 'downTeam',
        component: () => import('@/views/user/management/downTeam'),
        meta: {title: '下级团队'},
        hidden: true
      },
      {
        path: 'signalSource',
        name: 'signalSource',
        component: () => import('@/views/user/signalSource/index'),
        meta: {title: '信号源管理'}
      },
      {
        path: 'signalReview',
        name: 'signalReview',
        component: () => import('@/views/user/signalSource/review'),
        meta: {title: '信号源审核'},
        hidden: true
      },
      {
        path: 'inviteRecord',
        name: 'inviteRecord',
        component: () => import('@/views/user/inviteRecord/index'),
        meta: {title: '邀请记录'}
      },
      {
        path: 'rebate',
        name: 'rebate',
        component: () => import('@/views/user/rebate/index'),
        meta: {title: '返利用户'}
      }
    ]
  },
  {
    path:'/assets',
    component: Layout,
    redirect: '/assets/record',
    name: 'assets',
    meta: {title: '资产'},
    children: [
      {
        path: 'record',
        name: 'record',
        component: () => import('@/views/assets/record/index'),
        meta: {title: '资产记录'}
      },
      {
        path: 'withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/assets/withdrawal/index'),
        meta: {title: '用户出金管理'}
      },
      {
        path: 'proxyWith',
        name: 'proxyWith',
        component: () => import('@/views/assets/proxyWith/index'),
        meta: {title: '代理出金管理'}
      },
      {
        path: 'deposit',
        name: 'deposit',
        component: () => import('@/views/assets/deposit/index'),
        meta: {title: '入金管理'}
      },
      {
        path: 'bankCard',
        name: 'bankCard',
        component: () => import('@/views/assets/bankCard/index'),
        meta: {title: '银行卡管理'}
      },
      {
        path: 'adminBankCard',
        name: 'adminBankCard',
        component: () => import('@/views/assets/adminBankCard/index'),
        meta: {title: '后台银行卡管理'}
      },
      {
        path: 'withrawalAddress',
        name: 'withrawalAddress',
        component: () => import('@/views/assets/withrawalAddress/index'),
        meta: {title: '出金地址管理'}
      }
    ]
  },
  {
    path:'/report',
    component: Layout,
    redirect: '/report/statMoney',
    name: 'report',
    meta: {title: '报表'},
    children: [
      {
        path: 'statAll',
        name: 'statAll',
        component: () => import('@/views/home/stat'),
        meta: {title: '报表总览'}
      },
      {
        path: 'commission',
        name: 'commission',
        component: () => import('@/views/report/commission/index'),
        meta: {title: '佣金报表'}
      },
      {
        path: 'commissionRules',
        name: 'commissionRules',
        component: () => import('@/views/report/commission/rules'),
        meta: {title: '佣金细则报表'}
      },
      {
        path: 'statMoney',
        name: 'statMoney',
        component: () => import('@/views/report/statMoney/index'),
        meta: {title: '出入金报表'}
      },
      {
        path: 'statMoneyRules',
        name: 'statMoneyRules',
        component: () => import('@/views/report/statMoney/rules'),
        meta: {title: '出入金细则报表'}
      },
      {
        path: 'transaction',
        name: 'transaction',
        component: () => import('@/views/report/transaction/index'),
        meta: {title: '交易报表'}
      },
      {
        path: 'transactionRules',
        name: 'transactionRules',
        component: () => import('@/views/report/transaction/rules'),
        meta: {title: '交易细则报表'}
      },
    ]
  },
  {
    path:'/setUp',
    component: Layout,
    redirect: '/setUp/proxyLevel',
    name: 'setUp',
    meta: {title: '全局设置'},
    children: [
      {
        path: 'proxyLevel',
        name: 'proxyLevel',
        component: () => import('@/views/setUp/proxyLevel/index'),
        meta: {title: '代理等级设置'}
      },
      {
        path: 'userSetUp',
        name: 'userSetUp',
        component: () => import('@/views/setUp/userSetUp/index'),
        meta: {title: '用户等级设置'}
      },
      {
        path: 'userSetRules',
        name: 'userSetRules',
        component: () => import('@/views/setUp/userSetUp/setRules'),
        meta: {title: '用户返佣规则'},
        hidden: true
      },
      {
        path: 'systemSetUp',
        name: 'systemSetUp',
        component: () => import('@/views/setUp/systemSetUp/index'),
        meta: {title: '系统设置'}
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js